module.exports = __webpack_public_path__ + "../static/img/router-fail.bfd88f66.png";